import { EquipmentNameProps } from '../../types';
import { TextHighlight } from '../../../common';
import { CatHeading } from '@blocks-react/components/Heading';
import styles from '../../MyEquipment.module.scss';

export const EquipmentName = ({
  variant,
  textToHighlightTerm,
  text,
  isVirtualScroll = false,
  textColor
}: Readonly<EquipmentNameProps>) => {
  return (
    <div slot="trigger" className={`${styles['equipment-list--heading']}`}>
      <CatHeading variant={variant}>
        <TextHighlight
          text={text}
          textToHighlight={textToHighlightTerm}
          highlightClassName={`${textColor} text-truncate color-black d-block`}
          isVirtualScroll={isVirtualScroll}
          isSpecialCharacters
        />
      </CatHeading>
    </div>
  );
};
